<div class="header_hero-bg"></div>

<div class="mega-trade-container container-fluid">
  <div class="mega_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-2 offset-lg-2 committed-mega-text">
          <span class="status-icon">
            <i class="font-ex fa-exclamation-circle status-icon--md icon"></i>
          </span>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 committed-mega-text error-500-text">
          <p class="error-500-heading">The application has encountered an unexpected error.</p>
          <ng-container *ngIf="showStaticMessage">
            <p class="error-500-text">
              Our team is working as fast as we can to resolve the issue. If you require immediate
              assistance, contact Fannie Mae support.
            </p>
            <p class="error-500-text-resolution">
              Phone: 202-752-7875 <br />
              Email: Structured_Transactions&#64;fanniemae.com
            </p>
          </ng-container>
          <ng-container *ngIf="!showStaticMessage">
            <p class="error-500-text" *ngIf="displayErrorCode">
              {{ displayMessage ? displayMessage : '' }}
            </p>
            <p class="error-500-text" *ngIf="!displayErrorCode">
              Our team is working as fast as we can to resolve the issue. If you require immediate
              assistance, contact Fannie Mae support.
            </p>
            <p class="error-500-text-resolution" *ngIf="!displayErrorCode">
              Phone: 202-752-7875 <br />
              Email: Structured_Transactions&#64;fanniemae.com
            </p>
            <p class="error-500-text-resolution">
              {{ displayResolution ? displayResolution : '' }}
            </p>
          </ng-container>
          <div class="back-to-home" (click)="megaHomeButtonClicked()">
            <i class="fa fa-arrow-circle-o-left go-back-icon"></i> Back to home page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
